module.exports = __webpack_public_path__ + "img/nantong.343d2f7.png";